// src/i18n/zh-cn.js
export default {
  lang: {
    current: "中文",
    zh: "中文",
    en: "English"
  },
  menu: {
    home: '首页',
    meetingInfo: {
      base: '会议信息',
      sub:{
        info: '大会简介',
        guests: '大会嘉宾',
        schedule: '会议安排',
        org: '组织架构'
      }
    },
    submitPaper: '参会投稿',
    register: '注册报名',
    accommodation: '住宿交通',
    contact: '联系我们'
  },
  common: {
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    yes: '是',
    no: '否',
    unit: '张',
    cancelInfo: '已取消操作',
    edit: '编辑',
    back: '返回',
    download: '下载',
    labelAttachments: '附件'
  },
  order: {
    summary: '已有 {count} 个订单',
    badges: '共 {count} 张电子凭证',
    unit: {
      orders: '个订单',
      badges: '张电子凭证'
    },
    registerNow: '立即报名',
    button:{
      payNow: '立即支付',
      cancel: '取消订单',
      applyRefund: '申请退款',
      applyInvoice: '申请发票',
      viewSurvey: '查看住宿信息',
      needHotelRoom: '是否需要住宿',
      yes: '是',
      no: '否'
    },
    refund: {
      confirmMessage: '确定要申请退款吗？退款金额为 ¥{amount} 元。',
      confirm: '申请退款'
    },
    invoice: {
      confirmMessage: '确定要申请发票吗？发票金额为 ¥{amount} 元。',
      confirm: '申请发票'
    },
    cancelConfirm: '确定要取消该订单吗？取消后订单将无法恢复。',
    cancelSuccess: '订单取消成功',
    cancelFailed: '取消订单失败',
    cancelInfo: '已取消操作',
    paySuccess: '支付成功！',
    payFailed: '订单未支付，请先支付订单',
    payConfirmSuccess: '支付确认提交成功',
    payConfirmFailed: '支付确认提交失败，请稍后重试',
    createFailed: '订单创建失败，请检查信息后重试',
    createSuccess: '报名信息校验完成，订单创建成功',
    paymentConfigFailed: '支付配置信息获取失败，请稍后重试',
    eventEnded: '会议已结束~',
    defaultSubject: '订单支付',
    loadFailed: '加载订单失败',
    badgeLoadFailed: '获取电子凭证失败',
    payment: {
      dialogTitle: '支付费用',
      subjectLabel: '收费项目：',
      wechatPay: '微信支付',
      alipay: '支付宝支付',
      bankTransfer: '对公转账',
      scanTip: '请使用 {payType} 扫码支付',
      finishTip: '支付完成后请点击【我已付款】完成操作',
      receiveUnit: '收款单位：',
      bankNo: '银行账号：',
      bankBranch: '开户支行：',
      uploadTip: '转账完成，请上传转账截图凭证（仅支持jpg/png，1张）',
      selectImageBtn: '选择转账截图',
      selectedFile: '已选择：{name}',
      btnPaid: '我已付款',
      btnSubmitProof: '提交转账截图',
      msgSelectFile: '请先选择转账截图！',
      msgChargeInitWait: '支付通道尚未初始化，请稍候重试！',
      msgProofSuccess: '转账凭证提交成功，请等待工作人员核实！',
      msgProofFail: '提交失败',
      msgUploadFail: '上传失败，请重试',
      msgOnlyOneImage: '只能上传一张截图！'
    }
  },
  content: {
    brief: {
      title: '会议简介',
      desc: '本次会议围绕高速铁路、航空航天、先进制造、能源装备等重大工程领域中的关键承载结构服役安全问题，开展工程缺陷力学、疲劳断裂、损伤容限设计、结构可靠性评价、先进实验测试与数值模拟等方向的学术交流，促进相关领域国内外学者和工程技术人员合作。',
    },
    guest: {
      title: '会议嘉宾',
      chair: '主席',
      honorChair: '荣誉主席'
    },
    schedule: {
      title: '会议安排',
      main: '大会主会场',
      sub: '大会分会场',
      handbook: '点击下载会议手册'
    },
    organization: {
      title: '组织架构',
      host: '主办单位',
      co: '联合主办单位',
      undertake: '承办单位'
    },
    contact:{
      location: {
        title: '学会地址',
        content: '北京市海淀区知春路6号锦秋国际大厦A座23层'
      },
      telephone: {
        title: '联系电话',
        content: '010-82800755'
      },
      fax: {
        title: '传真',
        content: '010-82800879'
      },
      email: {
        title: 'E-mail',
        content: 'info@cis.org.cn'
      }
    },
    order: {
      title: '订单信息',
      orderno: '订单号',
      subject: '订单内容',
      amount: '订单金额',
      paytime: '支付时间',
      status: {
        refund_apply: '用户申请退款',
        refund_pending: '退款中',
        refunded: '已退款',
        completed: '已完成',
        free: '免费',
        expired: '已过期',
        cancel: '已取消',
        online: '当面付',
        bank: '银行转账',
        pending: '待支付',
        void: '已作废',
        delete: '已删除',
        bank_pending: '转账待确认'
      },
    },
    badge:{
      title: '报名电子凭证',
      qr:{
        tip: '请于现场出示此二维码'
      },
      unit: '张'
    }
  },
  register: {
    fillInfo : "请填写报名信息",
    attendee: "报名人",
    submit: "提交",
    reset: "重置",
    placeholder: {
      common: '请输入'
    },
    realname: '姓名',
    country: '国籍',
    cellphone: '手机号',
    company: '公司',
    title: '职务',
    email: 'Email',
    gender: '性别',
    position: '职务',
    department: '部门',
    institution: '机构',
    address: '地址',
    memo: '备注',
    idtype: '证件类型',
    idnumber: '证件号',
    ethnicity: '民族',
    birthdate: '出生日期',  
    ticket:{
      title: '选择票种'
    },
    amount: {
      free: "免费"
    },
    validateError: '请完善所有报名人信息',
    ticketTotal: '共 {count} 张，合计：¥{price}',
    viewRegisteredInfo: '查看已报名信息'
  },
  manuscript: {
    uploadAvatar: "上传作者照片",
    uploadAvatarTip: "点击上传作者证件照片",
    notice: "投稿须知",
    notice1: "仅支持 JPG 图片，尺寸不超过 500KB",
    notice2: "海报模板分为中文版、英文版，请按需下载",
    notice3: "投稿文件支持 PDF、PPT、PPTX、JPG 格式，最大20MB",
    templateZh: "中文海报模板",
    templateEn: "英文海报模板",
    download: "下载",
    uploadFile: "上传投稿文件",
    uploadFileTip: "上传投稿文件",
    uploadFileAction: "点击选择文件上传",
    requiredTip: "为必填项，请务必上传投稿文件",
    formTitle: "投稿信息",
    saveEditBtn: "保存修改",
    submitBtn: "提交投稿",
    labelAuthorFirst: "姓名",
    placeholderAuthorFirst: "请输入作者姓名",
    labelPhone: "联系电话",
    placeholderPhone: "请输入手机号码",
    labelEmail: "电子邮箱",
    placeholderEmail: "请输入邮箱地址",
    labelPublishCompany: "单位",
    placeholderPublishCompany: "请输入所在单位",
    labelPosterTitle: "标题",
    placeholderPosterTitle: "请输入标题",
    uploadFileRequired:"请上传文件",
    submitSuccess: "提交成功",
    submitFailed: "提交失败",
    submitTime: "提交时间",
    submitAgain: "再次提交",
    editTitle: "编辑投稿",
    updateBtn: "提交修改",
    updateSuccess:"投稿更新成功",
    labelAttachments:"附件",
    total:"已有 {count} 投稿",
    fileToal: "共{count}个",
    topicTitle: "（一）征稿主题：",
    labelAbstract: "征稿主题",
    placeholderAbstract: "请选择征稿主题",
    topicList: [
      "工程缺陷力学与重大装备服役安全",
      "疲劳断裂机理与损伤容限设计",
      "先进材料与轻量化结构设计评估",
      "先进测试表征、数值模拟与工程应用",
      '内蕴物理信息的机器学习建模方法及应用',
      "复合材料损伤、断裂与服役安全"
    ],
    formatTitle: "（二）投稿形式：",
    formatText: "原创性摘要或全文",
    formatTime:"（三）投稿截止时间：",
    formatTimeTip:"2026年10月10日",
    channelClosed:"投稿通道已关闭"
  },
  footer:{
    friendLink:"链接",
    bjtu:"北京交通大学",
    imech:"中国科学院力学研究所",
    swjtu:"西南交通大学",
    cstam:"中国力学学会"
  }
}